import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { EventDetailsPage } from './event-details';
import {ComponentsModule} from "../../components/components.module";
import {ContentLoaderModule} from "@netbasal/ngx-content-loader";

@NgModule({
  declarations: [
    EventDetailsPage,
  ],
  imports: [
    IonicPageModule.forChild(EventDetailsPage),
    ComponentsModule,
    ContentLoaderModule

  ],
})
export class EventDetailsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/event-details/event-details.module.ts